import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelDynamic as _vModelDynamic, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/bot_express_logo.png'


const _hoisted_1 = { class: "min-h-screen bg-zinc-900 flex items-center justify-center p-1 sm:p-4 font-nunito" }
const _hoisted_2 = { class: "w-full max-w-lg" }
const _hoisted_3 = { class: "bg-white/5 rounded-xl overflow-hidden" }
const _hoisted_4 = { class: "p-6 sm:p-8" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = ["type"]
const _hoisted_11 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_12 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "mt-8 text-center" }
const _hoisted_16 = { class: "text-[#888888] text-sm" }

import { Switch } from '@/components/ui/switch'
import { Toaster } from '@/components/ui/toast'
import { useAuth } from '@/composables/useAuth'
import { Loader2 } from 'lucide-vue-next'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

// Estado do formulário

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter()
const { login } = useAuth()
const email = ref('')
const password = ref('')
const remember = ref(false)
const showPassword = ref(false)
const isLoading = ref(false)

// Função de login
const handleLogin = async () => {
  isLoading.value = true
  try {
    const response = await login({ 
      email: email.value, 
      password: password.value, 
    })

    // Check if 2FA is required
    if (response.is2AF) {
      router.push({ name: '2fa' })
      return
    }

    router.push({ name: 'organizations' })
  } catch (error) {
    email.value = ''
    password.value = ''
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex items-center justify-center mb-8" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo",
            class: "h-auto w-[180px] sm:w-[280px]"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "mb-8" }, [
              _createElementVNode("h2", { class: "text-white text-2xl font-bold mb-2" }, "Bem-vindo de volta"),
              _createElementVNode("p", { class: "text-[#888888]" }, "Acesse sua conta para continuar")
            ], -1)),
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleLogin, ["prevent"]),
              class: "space-y-5"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[5] || (_cache[5] = _createElementVNode("label", {
                  for: "email",
                  class: "block text-sm font-medium text-[#AAAAAA]"
                }, "Email", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    type: "email",
                    required: "",
                    class: "w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-[#555555] focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200",
                    placeholder: "seu@email.com"
                  }, null, 512), [
                    [_vModelText, email.value]
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" }, [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      class: "text-[#555555]"
                    }, [
                      _createElementVNode("rect", {
                        width: "20",
                        height: "16",
                        x: "2",
                        y: "4",
                        rx: "2"
                      }),
                      _createElementVNode("path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" })
                    ])
                  ], -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", {
                    for: "password",
                    class: "block text-sm font-medium text-[#AAAAAA]"
                  }, "Senha", -1)),
                  _createVNode(_component_RouterLink, {
                    to: "/password-recovery",
                    class: "text-xs font-medium text-[#10B981] hover:text-[#0EA271] transition-colors"
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode(" Esqueceu a senha? ")
                    ])),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    id: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                    type: showPassword.value ? 'text' : 'password',
                    required: "",
                    class: "w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-[#555555] focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200",
                    placeholder: "••••••••"
                  }, null, 8, _hoisted_10), [
                    [_vModelDynamic, password.value]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value)),
                    class: "absolute inset-y-0 right-0 flex items-center pr-3 text-[#555555] hover:text-[#AAAAAA] transition-colors"
                  }, [
                    (!showPassword.value)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[8] || (_cache[8] = [
                          _createElementVNode("path", { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" }, null, -1),
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "3"
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_12, _cache[9] || (_cache[9] = [
                          _createElementVNode("path", { d: "M9.88 9.88a3 3 0 1 0 4.24 4.24" }, null, -1),
                          _createElementVNode("path", { d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" }, null, -1),
                          _createElementVNode("path", { d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" }, null, -1),
                          _createElementVNode("line", {
                            x1: "2",
                            x2: "22",
                            y1: "2",
                            y2: "22"
                          }, null, -1)
                        ])))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(Switch), {
                  modelValue: remember.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((remember).value = $event))
                }, null, 8, ["modelValue"]),
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  for: "remember",
                  class: "ml-2 text-sm text-[#AAAAAA] cursor-pointer"
                }, "Lembrar-me", -1))
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["w-full py-3 px-4 bg-[#10B981] hover:bg-[#0EA271] text-white font-medium rounded-md transition-colors duration-200 flex items-center justify-center", {
                'opacity-50 cursor-not-allowed pointer-events-none': !email.value || !password.value || isLoading.value
              }]),
                disabled: !email.value || !password.value || isLoading.value
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createBlock(_unref(Loader2), {
                      key: 0,
                      class: "w-4 h-4 animate-spin mr-2"
                    }))
                  : _createCommentVNode("", true),
                _cache[11] || (_cache[11] = _createElementVNode("span", null, "Entrar", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "18",
                  height: "18",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  class: "ml-2"
                }, [
                  _createElementVNode("path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" }),
                  _createElementVNode("polyline", { points: "10 17 15 12 10 7" }),
                  _createElementVNode("line", {
                    x1: "15",
                    x2: "3",
                    y1: "12",
                    y2: "12"
                  })
                ], -1))
              ], 10, _hoisted_14)
            ], 32),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, [
                _cache[14] || (_cache[14] = _createTextVNode(" Não tem uma conta? ")),
                _createVNode(_component_RouterLink, {
                  to: "/register",
                  class: "text-[#10B981] hover:text-[#0EA271] font-medium ml-1 transition-colors"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode(" Criar agora ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_unref(Toaster))
  ], 64))
}
}

})